import * as React from 'react';

import iconUrl from './MaternalCapitalIcon.svg';

/* istanbul ignore next */
export const MaternalCapitalIcon = () => <img width="32" height="36" src={iconUrl} alt="" />;

MaternalCapitalIcon.displayName = 'MaternalCapitalIcon';
